import React, { Fragment, useCallback, useEffect, useRef, useState } from "react"

import { Badge, Affix, Button, Spin, DatePicker, Select, Row, Col, Statistic, Alert, BackTop, Popconfirm } from "antd"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { faEraser, faGasPump, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"

import { useIsAuthenticated, useMsal } from "@azure/msal-react"
import { useNavigate } from "react-router"
import { Loading, Notify, Report } from "notiflix"
import { requestToken } from "../../../auth/AuthServices"
import moment from "moment"

import { CloudSyncOutlined } from "@ant-design/icons"
import "./styles.css"

import DistributionSelect from "../fuel-components/distributionSelect"
import { loginRequest } from "../../../config/api.config"
import { readFromIndexDB } from "../../../utils/idb"
import { callMsGraph } from "../../../utils/graph"

import { checkNetworkType } from "../../../utils/check_network"
import HeaderFarms from "../../../utils/header_farms"
import API from "../../../services"

// fix(fuel): stop adjusting history date filters by 8 hours

// Use the request dates as-is in both fuel history controllers so the date range matches the client input and no longer shifts results unexpectedly.
const PAGE_LIMIT = 10
const STATE_STORAGE_KEY = "fms_del_history_state"
const STATE_TTL_MS = 30 * 60 * 1000 // 30 menit

function FuelDeliveryHistory({ fuelType = null, fuelTypeOptions = null, onFuelTypeChange = null }) {
  let navigate = useNavigate()
  const { Option } = Select

  const { instance, accounts } = useMsal()
  const [historyDelivery, setHistoryDelivery] = useState([])
  const [startDate, setStartDate] = useState(moment().startOf("day"))
  const [endDate, setEndDate] = useState(moment().endOf("day"))
  const [loading, setLoading] = useState(false)
  const [loadingLoadServer, setLoadingLoadServer] = useState(false)
  const [loadingLoadIDB, setLoadingLoadIDB] = useState(true)
  const isAuthenticated = useIsAuthenticated()
  const [totalFuel, setTotalFuel] = useState(0)
  const [filter, setFilter] = useState(null)
  const [shift, setShift] = useState(null)
  const [deliveryRequestsIDB, setDeliveryRequestsIDB] = useState([])
  const [progressSyncStatus, setProgressSyncStatus] = useState(false)

  const [fuelShift] = useState(["SIANG", "MALAM"])

  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(false)
  const [totalServer, setTotalServer] = useState(0)
  const [loadingMore, setLoadingMore] = useState(false)
  const [currentVisiblePage, setCurrentVisiblePage] = useState(1)
  const [, setRestored] = useState(false)
  const observerTarget = useRef(null)
  const loadingRef = useRef(false)
  const fetchRangeRef = useRef({ startDate: null, endDate: null })
  const preloadedRef = useRef(false)
  const hasMoreRef = useRef(false)
  const loadMoreRef = useRef(null)
  const filterInitialRef = useRef(true)
  const restoredFilterRef = useRef(false)

  Notify.init({
    position: "center-center",
    distance: "50px",
    timeout: 2000,
  })

  const getShiftLabel = hour => {
    if (hour >= 18 && hour < 24) {
      return " (M)"
    } else if (hour >= 0 && hour < 5) {
    } else if (hour >= 0 && hour < 5) {
      return " (MD)"
    }
    return ""
  }

  function handleStartDateChange(date) {
    setStartDate(date || moment().startOf("day"))
    sessionStorage.setItem("startDate", date ? date.toISOString() : moment().startOf("day").toISOString())
  }

  function handleEndDateChange(date) {
    setEndDate(date || moment().endOf("day"))
    sessionStorage.setItem("endDate", date ? date.toISOString() : moment().endOf("day").toISOString())
  }

  async function getHistory(accessToken, startDate, endDate, pageToFetch = 1, reset = false) {
    if (reset) {
      fetchRangeRef.current = { startDate, endDate }
    }

    try {
      const res = await API.HistoryRequestDelivery(HeaderFarms(accessToken), {
        startDate,
        endDate,
        page: pageToFetch,
        limit: PAGE_LIMIT,
        fuel_truck: filter || undefined,
        shift: shift || undefined,
        fuel_type_delivery: fuelType || undefined,
      })

      const rawItems = Array.isArray(res?.data) ? res.data : []
      const nextItems = rawItems.map(it => ({ ...it, _page: pageToFetch }))
      const meta = res?.meta || {}

      setHistoryDelivery(current => (reset ? nextItems : [...current, ...nextItems]))
      setPage(meta.page || pageToFetch)
      setHasMore(Boolean(meta.hasMore))

      if (pageToFetch === 1) {
        setTotalServer(typeof meta.total === "number" ? meta.total : 0)
        setTotalFuel(meta.totalFlowmeterTotal ?? 0)
      }
    } catch (error) {
      Report.warning("Oops.. something wrong", "Sorry, this application is experiencing problems", "Okay")
      Loading.remove()
    } finally {
      setLoading(false)
      setLoadingLoadServer(false)
      setLoadingMore(false)
      loadingRef.current = false
    }
  }

  function search() {
    sessionStorage.removeItem(STATE_STORAGE_KEY)
    setLoading(true)
    setLoadingLoadServer(true)
    setHistoryDelivery([])
    setPage(1)
    setHasMore(false)
    setTotalServer(0)
    setCurrentVisiblePage(1)
    handleFilterByDate()
  }

  function handleChange(value) {
    setFilter(value)
  }

  function handleChangeFuelShift(value) {
    setShift(value)
  }

  function totalFuelCount(filterFromSelect, filterFromShift, requestsFuel) {
    // periksa apakah data berupa array
    if (!Array.isArray(requestsFuel)) {
      return
    }
    let total = 0
    requestsFuel.forEach(request => {
      const filterTruck = !filterFromSelect || request.fuel_truck === filterFromSelect
      const filterShift = !filterFromShift || request.shift === filterFromShift
      const requestFuelType = request?.fuel_type_delivery ?? request?.fuel_type ?? request?.fuel_type_request ?? request?.fuelType
      const filterFuelType = !fuelType || requestFuelType === fuelType

      if (filterTruck && filterShift && filterFuelType) {
        // Count fuel in
        total += request.flowmeter_total || 0
      }
    })

    setTotalFuel(total)
    return total
  }

  async function handleFilterByDate() {
    const accessToken = await requestToken()
    if (!accessToken) return

    try {
      await callMsGraph(accessToken)

      const savedStartDate = sessionStorage.getItem("startDate")
      const savedEndDate = sessionStorage.getItem("endDate")

      let startDateFormat = savedStartDate ? new Date(savedStartDate) : new Date(startDate)
      let endDateFormat = savedEndDate ? new Date(savedEndDate) : new Date(endDate)

      if (savedStartDate) setStartDate(moment(savedStartDate))
      if (savedEndDate) setEndDate(moment(savedEndDate))

      getHistory(accessToken, startDateFormat, endDateFormat, 1, true)
      if (!preloadedRef.current) {
        preloadedRef.current = true
        preloadDataForCache(accessToken)
      }
    } catch (e) {
      console.warn("Failed to filter by date:", e)
    }
  }

  const loadMoreHistory = useCallback(async () => {
    if (loadingRef.current || !hasMore) return
    loadingRef.current = true
    setLoadingMore(true)

    try {
      const accessToken = await requestToken(true, true)
      if (!accessToken) {
        loadingRef.current = false
        setLoadingMore(false)
        return
      }
      const { startDate: rangeStart, endDate: rangeEnd } = fetchRangeRef.current
      if (!rangeStart || !rangeEnd) {
        loadingRef.current = false
        setLoadingMore(false)
        return
      }
      await getHistory(accessToken, rangeStart, rangeEnd, page + 1, false)
    } catch (e) {
      console.warn("Failed to load more delivery history:", e)
      loadingRef.current = false
      setLoadingMore(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasMore, page, filter, shift, fuelType])

  const resetFilters = () => {
    setShift(null)
    setFilter(null)
    if (typeof onFuelTypeChange === "function") onFuelTypeChange(null)
  }

  const convertingArrayBufferToJson = dataArray => {
    // Mengumpulkan data yang telah di-parse menjadi JSON dalam sebuah array
    const parsedDataArray = dataArray.map(data => {
      try {
        const arrayBuffer = data.requestData.body
        let str = new TextDecoder().decode(arrayBuffer)
        // Extract the part that contains the JSON data
        let boundary = str.split("\r\n")[0] // Get the boundary from the first line
        let parts = str.split(boundary)
        let jsonData = null
        for (let i = 0; i < parts.length; i++) {
          if (parts[i].includes('name="json_data"')) {
            let jsonPart = parts[i]
            let startIndex = jsonPart.indexOf("{")
            let endIndex = jsonPart.lastIndexOf("}") + 1
            let jsonString = jsonPart.substring(startIndex, endIndex)
            try {
              jsonData = JSON.parse(jsonString)
              return jsonData
            } catch (e) {
              console.error("Error parsing JSON:", e)
            }
            break
          }
        }
      } catch (error) {
        console.error("Error parsing data:", error)
        return null
      }
    })

    return parsedDataArray
  }

  const fetchDataIDB = async () => {
    try {
      const dataArray = await readFromIndexDB()
      const resultConverting = convertingArrayBufferToJson(dataArray)
      const filterData = resultConverting.filter(item => item !== undefined)

      setDeliveryRequestsIDB(filterData)

      setLoadingLoadIDB(false)
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const syncManual = async () => {
    if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
      const accessToken = await requestToken()
      if (accessToken) {
        navigator.serviceWorker.controller.postMessage({
          msg: "MANUAL_SYNC",
          token: accessToken,
        })
      }
    } else {
      console.error("Service worker not available or not controlling the page")
    }
  }

  async function refreshLoadedDeliveryPages(token, range, totalPages, filters) {
    if (!range?.startDate || !range?.endDate || totalPages < 1) return

    const requests = Array.from({ length: totalPages }, (_, i) =>
      API.HistoryRequestDelivery(HeaderFarms(token), {
        startDate: range.startDate,
        endDate: range.endDate,
        page: i + 1,
        limit: PAGE_LIMIT,
        fuel_truck: filters.fuel_truck || undefined,
        shift: filters.shift || undefined,
        fuel_type_delivery: filters.fuel_type_delivery || undefined,
      }).catch(e => {
        console.warn("refresh delivery page failed", i + 1, e)
        return null
      })
    )

    const responses = await Promise.all(requests)
    const validResponses = responses.filter(Boolean)
    if (validResponses.length === 0) return

    const merged = validResponses.flatMap((r, idx) =>
      (Array.isArray(r?.data) ? r.data : []).map(item => ({
        ...item,
        _page: idx + 1,
      }))
    )

    const firstMeta = validResponses[0]?.meta || {}
    const lastMeta = validResponses[validResponses.length - 1]?.meta || {}

    setHistoryDelivery(merged)
    setHasMore(Boolean(lastMeta.hasMore))
    setTotalServer(typeof firstMeta.total === "number" ? firstMeta.total : 0)
    setTotalFuel(firstMeta.totalFlowmeterTotal ?? 0)
  }

  function saveCurrentState() {
    try {
      sessionStorage.setItem(
        STATE_STORAGE_KEY,
        JSON.stringify({
          historyDelivery,
          page,
          hasMore,
          totalServer,
          totalFuel,
          currentVisiblePage,
          filter,
          shift,
          fetchRange: fetchRangeRef.current
            ? {
                startDate: fetchRangeRef.current.startDate?.toISOString?.() || null,
                endDate: fetchRangeRef.current.endDate?.toISOString?.() || null,
              }
            : null,
          startDate: startDate?.toISOString?.() || null,
          endDate: endDate?.toISOString?.() || null,
          scrollY: window.scrollY,
          savedAt: Date.now(),
        })
      )
    } catch (e) {
      console.warn("Failed to save history state", e)
    }
  }

  function goDetail(id) {
    saveCurrentState()
    navigate(`/fms/delivery/view/${id}`)
  }

  // Pre-load data for PWA cache in the background
  const preloadDataForCache = async accessToken => {
    try {
      console.log("Preloading data for PWA cache...")
      const [resTank, resVehicle] = await Promise.all([API.StorageTank(HeaderFarms(accessToken), null), API.TankerVehicle(HeaderFarms(accessToken), null)])

      const tanks = resTank.data || []
      const vehicles = resVehicle.data || []
      const allDistribution = [...vehicles, ...tanks]

      console.log(`Pre-caching CalculateIssuedPeriod for ${allDistribution.length} distribution points.`)

      // Loop through each tanker/storage and call CalculateIssuedPeriod to cache it.
      // We don't need to wait for each call to finish (fire and forget).
      for (const item of allDistribution) {
        const receiveID = item.tank_code
        if (receiveID) {
          API.CalculateIssuedPeriod(HeaderFarms(accessToken), { receiveID }).catch(e => console.error(`Failed to pre-cache for ${receiveID}:`, e))
        }
      }
    } catch (error) {
      console.error("Failed to preload data for cache:", error)
    }
  }

  useEffect(() => {
    checkNetworkType()

    // Coba restore state dari sessionStorage saat user balik dari detail
    let didRestore = false
    try {
      const raw = sessionStorage.getItem(STATE_STORAGE_KEY)
      if (raw) {
        const saved = JSON.parse(raw)
        const fresh = Date.now() - (saved.savedAt || 0) < STATE_TTL_MS
        if (fresh && Array.isArray(saved.historyDelivery) && saved.historyDelivery.length > 0) {
          setHistoryDelivery(saved.historyDelivery)
          setPage(saved.page || 1)
          setHasMore(Boolean(saved.hasMore))
          setTotalServer(saved.totalServer || 0)
          setTotalFuel(saved.totalFuel || 0)
          setCurrentVisiblePage(saved.currentVisiblePage || 1)
          if (saved.filter !== undefined) setFilter(saved.filter)
          if (saved.shift !== undefined) setShift(saved.shift)
          restoredFilterRef.current = true
          if (saved.startDate) setStartDate(moment(saved.startDate))
          if (saved.endDate) setEndDate(moment(saved.endDate))
          if (saved.fetchRange?.startDate && saved.fetchRange?.endDate) {
            fetchRangeRef.current = {
              startDate: new Date(saved.fetchRange.startDate),
              endDate: new Date(saved.fetchRange.endDate),
            }
          }
          setLoading(false)
          setLoadingLoadServer(false)
          setRestored(true)
          didRestore = true
          setTimeout(() => window.scrollTo({ top: saved.scrollY || 0, behavior: "auto" }), 150)

          // Silent refresh: re-fetch loaded pages buat update approval status
          void (async () => {
            const token = await requestToken(true, true)
            if (!token) return
            await refreshLoadedDeliveryPages(token, fetchRangeRef.current, saved.page || 1, {
              fuel_truck: saved.filter,
              shift: saved.shift,
              fuel_type_delivery: fuelType,
            })
          })()
        }
      }
    } catch (e) {
      console.warn("Failed to restore history state", e)
    }

    if (!didRestore) {
      search()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps

    if (localStorage.getItem("IDB") === "0") {
      setTimeout(() => {
        fetchDataIDB()
      }, 1000)
    } else {
      setLoadingLoadIDB(false)
      localStorage.setItem("IDB", "0")
    }

    if ("serviceWorker" in navigator) {
      const messageHandler = async event => {
        try {
          if (event.data && event.data.msg) {
            if (event.data.msg === "IDB_COMPLETE") {
              localStorage.setItem("IDB", "1")
            }

            if (event.data.msg === "PROGRESS_SYNC") {
              Report.success("Sedang Mengirim ke server", "Proses ini berjalan di latar belakang, mohon untuk tidak menutup halaman.", {
                timeout: 2000,
              })
              setProgressSyncStatus(true)
            }

            if (event.data.msg === "OK_SYNC") {
              fetchDataIDB()
              Report.success(`${event.data.detail}`, {
                timeout: 3000,
              })
              setProgressSyncStatus(true)
            }

            if (event.data.msg === "NO_OK_SYNC") {
              Report.failure("Gagal kirim data, pastikan anda dalam kondisi online.")
              Report.failure(event.data.detail.toString(), { timeout: 5000 })
              setProgressSyncStatus(false)
            }

            if (event.data.msg === "NO_DATA_SYNC") {
              setTimeout(() => {
                Report.info(`Tidak ada data di local anda.`, "Mohon lakukan pengecekan transaksi. ", "Ok")
                setProgressSyncStatus(false)
              }, 2000)
            }

            if (event.data.msg === "COMPLETE_SYNC") {
              setTimeout(() => {
                setDeliveryRequestsIDB([])
                search()
                Report.success(`Berhasil terkirim ke server ..`, "Mohon lakukan pengecekan transaksi. ", "Ok")
                setProgressSyncStatus(false)
              }, 2000)
            }
          }
        } catch (error) {
          console.error("Error processing service worker message:", error)
        }
      }

      navigator.serviceWorker.addEventListener("message", messageHandler)
      return () => navigator.serviceWorker.removeEventListener("message", messageHandler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  // Sync refs dengan state terbaru supaya observer yang persistent tetap bisa akses
  useEffect(() => {
    hasMoreRef.current = hasMore
  }, [hasMore])
  useEffect(() => {
    loadMoreRef.current = loadMoreHistory
  }, [loadMoreHistory])

  // Observer dibuat SEKALI, tidak re-create tiap state berubah (cegah immediate-fire loop)
  useEffect(() => {
    const target = observerTarget.current
    if (!target) return

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && hasMoreRef.current && !loadingRef.current) {
          loadMoreRef.current?.()
        }
      },
      { threshold: 0.1 }
    )

    observer.observe(target)
    return () => observer.disconnect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Filter berubah → reset list + re-fetch page 1 dengan filter baru (date range tetap dari fetchRangeRef)
  useEffect(() => {
    if (filterInitialRef.current) {
      filterInitialRef.current = false
      return
    }
    if (restoredFilterRef.current) {
      restoredFilterRef.current = false
      return
    }
    const { startDate: rs, endDate: re } = fetchRangeRef.current
    if (!rs || !re) return
    ;(async () => {
      const accessToken = await requestToken(true, true)
      if (!accessToken) return
      sessionStorage.removeItem(STATE_STORAGE_KEY)
      setHistoryDelivery([])
      setPage(1)
      setHasMore(false)
      setTotalServer(0)
      setCurrentVisiblePage(1)
      setLoading(true)
      setLoadingLoadServer(true)
      await getHistory(accessToken, rs, re, 1, true)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, shift, fuelType])

  // Tracking halaman aktif (yang sedang di viewport) via IntersectionObserver
  useEffect(() => {
    if (historyDelivery.length === 0) return

    const markers = document.querySelectorAll("[data-page-marker]")
    if (markers.length === 0) return

    const observer = new IntersectionObserver(
      entries => {
        const visible = entries
          .filter(e => e.isIntersecting)
          .map(e => parseInt(e.target.getAttribute("data-page-marker"), 10))
          .filter(n => !Number.isNaN(n))
        if (visible.length > 0) {
          setCurrentVisiblePage(Math.min(...visible))
        }
      },
      { rootMargin: "-10% 0% -80% 0%", threshold: 0 }
    )

    markers.forEach(m => observer.observe(m))
    return () => observer.disconnect()
  }, [historyDelivery])

  return (
    <Fragment>
      {historyDelivery.length > 0 && (
        <div
          style={{
            position: "fixed",
            top: 70,
            right: 12,
            zIndex: 100,
            background: "#1890FF",
            color: "white",
            padding: "4px 10px",
            borderRadius: 12,
            fontSize: 12,
            fontWeight: "bold",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          }}
        >
          Hal. {currentVisiblePage} / {totalServer > 0 ? Math.ceil(totalServer / PAGE_LIMIT) : Math.max(page, currentVisiblePage)}
        </div>
      )}
      <div className="container-fluid p-0 mt-3">
        <div className="row">
          <div className="col">
            <Affix offsetTop={10}>
              <div className="d-flex justify-content-start">
                <Button
                  onClick={() => {
                    sessionStorage.removeItem(STATE_STORAGE_KEY)
                    navigate("/fms/delivery/create")
                  }}
                  size="middle"
                  className="btn-color-gradient"
                >
                  <FontAwesomeIcon icon={faGasPump} style={{ marginRight: "5px" }} />
                  New Delivery
                </Button>
              </div>
            </Affix>
          </div>
          <div className="col" style={{ marginTop: -10 }}>
            <Statistic title="Fuel Delivery (LT)" value={totalFuel} />
          </div>
        </div>
        <div className="row mb-2 mt-4">
          <div className="d-flex gap-3 flex-wrap align-items-end">
            {/* Date Time Pickers */}
            <div className="col-sm-5 col-md-auto">
              <label style={{ marginBottom: 5 }}>Dari Tanggal & Jam:</label>
              <DatePicker showTime={{ format: "HH:mm" }} format="YYYY-MM-DD HH:mm" onChange={handleStartDateChange} placeholder="Pilih tanggal & jam" value={startDate} style={{ width: "100%" }} />
            </div>
            <div className="col-sm-5 col-md-auto">
              <label style={{ marginBottom: 5 }}>Sampai Tanggal & Jam:</label>
              <DatePicker showTime={{ format: "HH:mm" }} format="YYYY-MM-DD HH:mm" onChange={handleEndDateChange} placeholder="Pilih tanggal & jam" value={endDate} style={{ width: "100%" }} />
            </div>

            {/* Action Buttons */}
            <div className="d-flex gap-2">
              <div className="align-self-end">
                <Button className="btn-color-gradient" onClick={search} loading={loading} disabled={loading}>
                  <FontAwesomeIcon icon={faMagnifyingGlass} style={{ color: "#ffffff", marginRight: "3px" }} />
                  Cari
                </Button>
              </div>
              <div className="align-self-end">
                <Button className="delete-filter" type="dashed" onClick={resetFilters} size="middle">
                  <FontAwesomeIcon icon={faEraser} style={{ color: "#ffffff", paddingRight: "8px" }} />
                  Hapus Filter
                </Button>
              </div>
              <div className="align-self-end">
                {!progressSyncStatus ? (
                  <Popconfirm
                    placement="topRight"
                    title="Kirim transaksi?"
                    onConfirm={syncManual}
                    okText="Ya Kirim"
                    cancelText="Batal"
                    overlayStyle={{ minWidth: 260 }}
                    overlayInnerStyle={{ padding: 12 }}
                    okButtonProps={{ size: "small", style: { marginLeft: 8 } }}
                    cancelButtonProps={{ size: "small" }}
                  >
                    <Button type="primary" icon={<CloudSyncOutlined style={{ fontSize: 20 }} />} size="middle">
                      Kirim Transaksi
                    </Button>
                  </Popconfirm>
                ) : (
                  <Spin style={{ marginLeft: 10, fontSize: 15 }} size="small" tip="Proses pengiriman ke server"></Spin>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <Row gutter={[12, 12]} align="bottom">
              <Col xs={12} md={6} xl={5}>
                <label style={{ marginBottom: 5 }}>Distribution Tank</label>
                <DistributionSelect size={"middle"} placeholder="Select Distribution Tank" value={filter} onChange={handleChange}></DistributionSelect>
              </Col>
              <Col xs={12} md={6} xl={4}>
                <label style={{ marginBottom: 5 }}>Shift :</label>
                <Select style={{ width: "100%" }} value={shift} onChange={handleChangeFuelShift} size="middle" placeholder="Select Shift" allowClear>
                  {fuelShift.map(s => {
                    return (
                      <Option key={s} value={s}>
                        {s}
                      </Option>
                    )
                  })}
                </Select>
              </Col>
              <Col xs={12} md={6} xl={4}>
                <label style={{ marginBottom: 5 }}>Jenis BBM :</label>
                <Select
                  allowClear
                  placeholder="Semua Jenis"
                  value={fuelType || undefined}
                  onChange={v => {
                    if (typeof onFuelTypeChange === "function") onFuelTypeChange(v)
                  }}
                  style={{ width: "100%" }}
                >
                  {(fuelTypeOptions && fuelTypeOptions.length > 0
                    ? fuelTypeOptions
                    : [
                        { value: "Solar", label: "Solar" },
                        { value: "Benzine", label: "Bensin" },
                      ]
                  ).map(opt => (
                    <Option key={opt.value} value={opt.value}>
                      {opt.label}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-10 offset-md-1">
            {loadingLoadServer && (
              <div
                className="d-flex justify-content-center gap-3 my-4"
                style={{
                  flexWrap: "wrap",
                  transition: "opacity 1s ease, transform 1s ease, max-height 1s ease",
                  opacity: loadingLoadServer ? 1 : 0,
                  transform: loadingLoadServer ? "translateY(0)" : "translateY(-10px)",
                  maxHeight: loadingLoadServer ? 200 : 0,
                  overflow: "hidden",
                  pointerEvents: loadingLoadServer ? "auto" : "none",
                }}
              >
                {loadingLoadServer && (
                  <Alert
                    showIcon={false}
                    message={
                      <div className="text-center">
                        <Spin size="small" style={{ marginRight: 8 }} />
                        Mengambil data dari server
                      </div>
                    }
                  />
                )}
              </div>
            )}
            <div
              className="d-flex justify-content-center gap-3 my-4"
              style={{
                flexWrap: "wrap",
                transition: "opacity 1s ease, transform 1s ease, max-height 1s ease",
                opacity: loadingLoadIDB ? 1 : 0,
                transform: loadingLoadIDB ? "translateY(0)" : "translateY(-10px)",
                maxHeight: loadingLoadIDB ? 200 : 0,
                overflow: "hidden",
                pointerEvents: loadingLoadIDB ? "auto" : "none",
              }}
            >
              {loadingLoadIDB && (
                <Alert
                  showIcon={false}
                  message={
                    <div className="text-center">
                      <Spin size="small" style={{ marginRight: 8 }} />
                      Mengambil data dari lokal
                    </div>
                  }
                />
              )}
            </div>
            {deliveryRequestsIDB.length > 0 &&
              deliveryRequestsIDB.map(data => {
                if (data?.fuel_type_delivery) {
                  const itemFuelType = data?.fuel_type_delivery ?? data?.fuel_type ?? data?.fuel_type_request ?? data?.fuelType
                  if (fuelType && itemFuelType !== fuelType) return null
                  return (
                    <Fragment key={data?.id_record}>
                      <Badge.Ribbon color="red" text={data?.flowmeter_total + " LT"}>
                        <div className="list-style p-2 px-3" style={{ background: "#B2DAFF" }}>
                          <div className="title d-flex justify-content-between">
                            <div className="fs-7 mb-0">
                              <b>
                                TO : {data.fuel_truck} {"|"} FROM : {data.location_storage}
                              </b>
                            </div>
                            <div className="fs-7 mb-0" style={{ fontSize: 13 }}>
                              <>
                                {" "}
                                Belum dikirim ke server <Badge style={{ marginLeft: 10 }} status="error" />
                              </>
                            </div>
                          </div>
                          <div className="title mt-2">
                            <p style={{ fontSize: 11 }}>{data?.operator_id}</p>
                          </div>
                          <div className="hour d-flex justify-content-between">
                            <p className="fs-7">
                              <span style={{ fontSize: 11 }}>
                                {" "}
                                {moment(data?.date).format("YYYY-MM-DD")} {moment(data?.time).format("HH:mm")}
                                {getShiftLabel(parseInt(moment(data?.time).format("HH")))}
                              </span>
                            </p>
                          </div>
                        </div>
                      </Badge.Ribbon>
                    </Fragment>
                  )
                }
              })}
            {historyDelivery.length > 0 && (
              <>
                {historyDelivery
                  .filter(data => {
                    const filterTruck = !filter || data.fuel_truck === filter
                    const filterShift = !shift || data.shift === shift
                    const itemFuelType = data?.fuel_type_delivery ?? data?.fuel_type ?? data?.fuel_type_request ?? data?.fuelType
                    const filterFuelType = !fuelType || itemFuelType === fuelType
                    return filterTruck && filterShift && filterFuelType
                  })
                  .map((data, index, filteredArray) => {
                    const prevPage = index > 0 ? filteredArray[index - 1]?._page : null
                    const showPageMarker = data?._page && data._page !== prevPage
                    return (
                      <Fragment key={data.id_record}>
                        {showPageMarker && (
                          <div
                            data-page-marker={data._page}
                            style={{
                              textAlign: "center",
                              margin: "12px 0 8px",
                              color: "#1890FF",
                              fontSize: 11,
                              fontWeight: "bold",
                              letterSpacing: 1,
                            }}
                          >
                            ── Halaman {data._page} ──
                          </div>
                        )}
                        <Badge.Ribbon text={data.flowmeter_total + " LT"}>
                          <div className="list-style p-2 px-2" onClick={() => goDetail(data.record_id)}>
                            <div className="title d-flex justify-content-between align-items-center">
                              <div style={{ fontSize: 11 }} className="fs-7 mb-0 d-flex align-items-center">
                                <Badge color={data.background_sync ? "red" : "green"} dot style={{ marginRight: 8 }}></Badge>
                                <b>
                                  TO : {data.fuel_truck} {"|"} FROM : {data.location_storage}
                                </b>
                              </div>
                              <div className="fs-7 mb-0" style={{ fontSize: 10 }}>
                                <span
                                  style={
                                    data.status_approval.status !== "Approved"
                                      ? {
                                          background: "#E0710F",
                                          padding: 3,
                                          marginLeft: 13,
                                          color: "#FFFFFF",
                                          borderRadius: 4,
                                          fontSize: 10,
                                        }
                                      : {
                                          background: "#1890FF",
                                          padding: 3,
                                          marginLeft: 13,
                                          color: "#FFFFFF",
                                          borderRadius: 4,
                                          fontSize: 10,
                                        }
                                  }
                                >
                                  {data.status_approval.status}
                                </span>{" "}
                                <br />
                                <br />
                                {data.updated_by && (
                                  <span
                                    className="delete-filter"
                                    style={{
                                      padding: 2,
                                      borderRadius: 4,
                                      fontSize: 9,
                                      position: "absolute",
                                      right: 70,
                                      bottom: 13,
                                    }}
                                  >
                                    Adjust by : {data.updated_by}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="title">
                              <p style={{ color: "#B7B7B7", fontSize: 11 }}>
                                Fuelman : {data.created_by} | Driver : {data.operator?.fullname}
                              </p>
                            </div>
                            <div className="hour d-flex justify-content-between">
                              <p className="fs-7">
                                <span
                                  style={
                                    data.shift !== "SIANG"
                                      ? {
                                          color: "#000000",
                                          fontSize: 11,
                                          fontWeight: "bold",
                                        }
                                      : {
                                          color: "#E0710F",
                                          fontSize: 11,
                                          fontWeight: "bold",
                                        }
                                  }
                                >
                                  {data.shift}
                                </span>{" "}
                                <span style={{ color: "#B7B7B7", fontSize: 11 }}>
                                  {" "}
                                  {moment(data.date).format("YYYY-MM-DD")} {moment(data.time).format("HH:mm")}
                                  {getShiftLabel(parseInt(moment(data.time).format("HH")))}
                                </span>
                              </p>
                            </div>
                          </div>
                        </Badge.Ribbon>
                      </Fragment>
                    )
                  })}
              </>
            )}
            <div ref={observerTarget} style={{ height: 1 }} />
            {loadingMore && (
              <div className="d-flex justify-content-center my-3">
                <Spin size="large" tip="Memuat lebih banyak..." />
              </div>
            )}
            {!hasMore && historyDelivery.length > 0 && (
              <div className="d-flex justify-content-center my-3" style={{ color: "#8c8c8c", fontSize: 11 }}>
                Semua data sudah ditampilkan ({totalServer} total)
              </div>
            )}
            <BackTop />

            {historyDelivery.length === 0 && !loading && (
              <div className="fs-6 text-center mt-5" style={{ color: "#B7B7B7" }}>
                No more data
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default FuelDeliveryHistory
